import React, { useState, useEffect } from 'react';
import { newsService } from '../../../services/newsService';
import { NewsItem } from '../../../types';

const NotificationsPage: React.FC = () => {
  const [notifications, setNotifications] = useState<NewsItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadNotifications();
  }, []);

  const loadNotifications = async () => {
    try {
      setIsLoading(true);
      const newsData = await newsService.getAllNews();
      // A página de notificações deve mostrar apenas as não lidas
      setNotifications(newsData.filter(item => !item.isRead));
    } catch (error) {
      console.error('Erro ao carregar notificações:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const markAsRead = async (newsId: string) => {
    try {
      await newsService.markAsRead(newsId);
      // Remove a notificação da lista localmente para uma UI mais rápida
      setNotifications(prev => prev.filter(item => item.id !== newsId));
    } catch (error) {
      console.error('Erro ao marcar notícia como lida:', error);
    }
  };

  const getImpactIcon = (impact: string) => {
    switch (impact) {
      case 'positive': return '📈';
      case 'negative': return '📉';
      default: return '➡️';
    }
  };

  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen-1/2 gap-4">
        <div className="w-12 h-12 border-4 border-gray-200 border-t-blue-700 rounded-full animate-spin"></div>
        <p>Carregando notificações...</p>
      </div>
    );
  }

  return (
    <div className="p-4">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Notificações</h1>
        <p className="text-lg text-gray-600">Alertas e notificações recentes</p>
      </div>

      {notifications.length > 0 ? (
        <div className="flex flex-col gap-4">
          {notifications.map(item => (
            <div key={item.id} className="bg-white rounded-xl p-6 shadow-sm border border-gray-200 flex gap-4 items-start">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center text-xl">
                <span className={`${
                    item.impact === 'positive' ? 'text-green-500' :
                    item.impact === 'negative' ? 'text-red-500' :
                    'text-gray-600'
                  }`}
                >
                  {getImpactIcon(item.impact)}
                </span>
              </div>
              <div className="flex-1">
                <h4 className="text-lg font-semibold text-gray-900 mb-2">{item.title}</h4>
                <p className="text-gray-600 leading-relaxed mb-3">{item.summary}</p>
                <span className="text-sm text-gray-600">{item.time}</span>
              </div>
              <button
                className="px-4 py-2 bg-blue-700 text-white border-none rounded-lg text-sm font-medium cursor-pointer transition-colors duration-200 ml-auto hover:bg-blue-800"
                onClick={() => markAsRead(item.id)}
              >
                Marcar como lida
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-16 px-8 bg-white rounded-xl border border-gray-200">
          <h3 className="text-2xl text-gray-900 mb-2">✨ Tudo em dia!</h3>
          <p className="text-gray-600">Você não tem nenhuma notificação nova.</p>
        </div>
      )}
    </div>
  );
};

export default NotificationsPage;
